export const LISTING = 'RESCUE_BONUS_SETTING_LIST';
export const DROPDOWN = "RESCUE_BONUS_SETTING_DROPDOWN";
export const STORE = "RESCUE_BONUS_SETTING_STORE";
export const DETAILS = "RESCUE_BONUS_SETTING_DETAILS";
export const UPDATE = "RESCUE_BONUS_SETTING_UPDATE";